<script setup lang="ts">
/**
 * UI-kit component
 * Category: Headers
 * Name: HeaderCtaGroup
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=327-26416
 *
 * The header action buttons wrapper. view=bar: transparent horizontal row
 * (gap space/16 — the in-bar copies diverge from the component's space/12 by
 * design). view=sheet: the strip pinned to the sheet foot — vertical, full-width
 * buttons on surface/secondary with a 1px top border and space/20 padding.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui.
 */
// types
import type { HeaderCtaGroupProps } from '../types/interfaces'

defineOptions({
  name: 'HeaderCtaGroup',
})

withDefaults(defineProps<HeaderCtaGroupProps>(), {
  view: 'bar',
})
</script>

<template>
  <div
    class="header-cta-group"
    :class="`header-cta-group--${view}`"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped src="../styles/_header-cta-group.scss" />
